import { render, staticRenderFns } from "./bookSetting.vue?vue&type=template&id=2c84ed7b&scoped=true&"
import script from "./bookSetting.vue?vue&type=script&lang=js&"
export * from "./bookSetting.vue?vue&type=script&lang=js&"
import style0 from "./bookSetting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bookSetting.vue?vue&type=style&index=1&id=2c84ed7b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84ed7b",
  null
  
)

export default component.exports